import { Component, OnInit, Input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { TabType } from 'src/app/services/API.service';

@Component({
  selector: 'app-tab',
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.css']
})
export class TabComponent implements OnInit {
  @Input() Tab: FormGroup;
  @Input() Email: string[] = [];
  eTabType = TabType;
  blacklist = [];

  constructor() { }

  ngOnInit(): void {
    this.setBlacklist(this.Exclusions.value);
  }

  onChangeBlackList(event) {

    this.Exclusions.setValue(event);
    this.Exclusions.markAsDirty();

  }

  setBlacklist(data: string[]) {
    const l = [];

    if (data) {
      data.forEach(e => {
        l.push({ value: false, text: e });
      });

      this.blacklist = l;
    }
  }

  get Type() {
    return this.Tab.get('Type') as FormControl;
  }

  get UserID() {
    return this.Tab.get('UserID') as FormControl;
  }

  get Exclusions() {
    return this.Tab.get('ExclusionList');
  }

  get Created() {
    return this.Tab.get('Created').value;
  }

  get Modified() {
    return this.Tab.get('Modified').value;
  }

  get Table() {
    return this.Tab.get('Table') as FormGroup;
  }

  get Note() {
    return this.Tab.get('Note') as FormGroup;
  }
}
